// Qué le ahorra la promoción al cliente en el paso 06: la cotización con la tasa del PLAN contra la
// que el motor cobró de verdad.
//
// Los dos lados salen del MISMO motor local para que el tachado y el número grande sean comparables
// al centavo; el número grande sigue siendo el del silo.
import { quoteWeeklyFromDownPayment } from '@/shared/domain/quote';

export interface PromoSavings {
    /** Tasa del plan: la que se cobraría sin promoción. */
    baseTna: number;
    /** Tasa con la que cotizó el motor. */
    appliedTna: number;
    /** Cuota semanal fija con IVA sin la promoción, la misma del hero. */
    weeklyWithout: number;
    interestWithout: number;
    /** Lo financiado + intereses + IVA sin la promoción. No incluye el enganche. */
    totalWithout: number;
    weeklySaving: number;
    totalSaving: number;
}

/**
 * `null` cuando no hay nada que tachar: sin plan, con términos incompletos, o cuando la tasa
 * aplicada no es MEJOR que la del plan. Una tasa igual o peor no es una promoción, y anunciarla
 * como ahorro sería inventar el número.
 */
export function promoSavings(input: {
    price: number;
    downPayment: number;
    weeks: number;
    baseTna: number;
    appliedTna: number;
    openingFeePct?: number;
}): PromoSavings | null {
    const { price, downPayment, weeks, baseTna, appliedTna, openingFeePct } = input;
    if (appliedTna <= 0 || baseTna <= appliedTna) return null;

    const terms = { price, downPayment, weeks, openingFeePct };
    const without = quoteWeeklyFromDownPayment({ ...terms, tna: baseTna });
    const with_ = quoteWeeklyFromDownPayment({ ...terms, tna: appliedTna });
    if (!without.valid || !with_.valid) return null;

    const weeklyWithout = without.weeks[0].payment;
    const totalWithout = without.financed + without.totals.interest + without.totals.vat;
    const totalWith = with_.financed + with_.totals.interest + with_.totals.vat;

    return {
        baseTna,
        appliedTna,
        weeklyWithout,
        interestWithout: without.totals.interest,
        totalWithout,
        weeklySaving: weeklyWithout - with_.weeks[0].payment,
        totalSaving: totalWithout - totalWith,
    };
}
